export default __webpack_public_path__ + "static/media/avata.05b02728.jpg";